import { render, staticRenderFns } from "./attributeTable.vue?vue&type=template&id=39299f76&scoped=true"
import script from "./attributeTable.vue?vue&type=script&lang=js"
export * from "./attributeTable.vue?vue&type=script&lang=js"
import style0 from "./attributeTable.vue?vue&type=style&index=0&id=39299f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39299f76",
  null
  
)

export default component.exports